import { UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';
import { QUERY_KEY_TO_PERSIST } from '../../../modules/offline/queryClient/offlineQueryClient';

export const getGetTeamKey = (): UseDataQuery['queryKey'] => [
  '/users/team/v1',
  undefined,
  QUERY_KEY_TO_PERSIST,
];

export const getFindTeamsKey = (): UseDataQuery['queryKey'] => [
  '/users/teams/v1',
  undefined,
  QUERY_KEY_TO_PERSIST,
];

export const getFindAdminUserTeamsKey = (userId: string): UseDataQuery['queryKey'] => [
  '/admin/users/:id/teams',
  userId,
];

export const getGetAbilitiesKey = (): UseDataQuery['queryKey'] => [
  '/users/abilities/v1',
  undefined,
  QUERY_KEY_TO_PERSIST,
];
